// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"coordinate-system"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M11.9999 3L21.5262 19.5H2.47363L11.9999 3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M11.9999 3L21.5262 19.5H2.47363L11.9999 3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 10V13M12 13L9 15.5M12 13L15 15.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CoordinateSystemIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'coordinate-system',
    ref,
    icon: element,
  },
));

CoordinateSystemIcon.displayName = 'CoordinateSystemIcon';

export default CoordinateSystemIcon;
